import axios from "axios";
import { instance } from "../network/ApiCall";

export async function fetchForgetPass(data:any) {
  const response = await instance.post(`/users/sendOTP?username=${data.username}`); 
  return response.data;
}

export async function fetchVerifyOtp(data:any) {
  const response = await instance.post(`/users/verifyOtp?Otp=${data.otp}&username=${data.username}`); 
  return response.data;
}
export async function fetchSetPassword(data:any) {
  const response = await instance.put(`/users/set?employeeId=${data.username}`, data); 
  return response.data;
}